import { CarouseContainerlWrapperProps, CarouselBase } from './CarouselBase';

export function ImageCarousel<T>(props: CarouseContainerlWrapperProps<T>) {
  return <CarouselBase {...props} />;
}
